/**
 * Initial state
 */
export const state = {
  drawer: true,
  mini: false,
}

/**
 * Mutations
 */
export const mutations = {
  SET_DRAWER: (state,  payload) => {
      state.drawer = payload
  },

  SET_MINI: (state, payload) => {
      state.mini = payload
  },

  SET_LANG (state, payload) {
      state.locale = payload;
  },
}

/**
 * Actions
 */
export const actions = {

}

/**
 * Getters
 */
export const getters = {
  drawer: state => state.drawer,
  mini: state => state.drawer,
}
